<template>
	<section class="app-presets">
		<div class="app-presets__top">
			<h2 class="app-presets__title">
				{{ $t('presets') }} <span class="flag flag--base-font-color">{{ presets.length }}</span>
			</h2>
			<div class="app-presets__search">
				<label class="app-field">
					<div class="app-field__holder">
						<input
							type="text"
							class="app-field__input"
							placeholder="Поиск подборки"
							v-model="searchModel"
							@keydown.enter="searchPresets"
							@keydown.esc="clearSearch"
						>
						<button v-show="isShowClearSearchBtn" class="app-field__btn remove-btn remove-btn--app-field remove-btn--red" @click="clearSearch">
							<span class="visually-hidden">Очистить поиск</span>
						</button>
					</div>
				</label>
				<button @click="searchPresets" class="app-btn app-btn--primary">Найти</button>
			</div>
		</div>

		<template v-if="filteredPresets.length">
			<ul
				class="app-presets__list"
				:class="{
					'app-presets__list--show-more': show_more_presets,
					'is-show-more': isShowMorePresets
				}"
			>
				<li class="app-presets__item" v-for="(preset, index) in filteredPresets" :key="'preset-' + preset.id + '-' + index">
					<article class="app-presets-card" :style="`background-image: url(${preset.picture_url});`">
						<a :href="preset.url" class="app-presets-card__link">
							<h3 v-if="preset.is_private" class="visually-hidden">{{ preset.name }}</h3>
							<h3 v-else class="app-presets-card__title">{{ preset.name }}</h3>
							<div class="app-presets-card__bottom">
								<ul class="app-presets-card__list">
									<li class="app-presets-card__item">
										<div class="course-tag course-tag--bg-white">{{ $t('courses', preset.courses_count) }}</div>
									</li>
								</ul>
							</div>
						</a>
					</article>
				</li>
			</ul>

			<div v-if="show_more_presets && filteredPresets.length > 6" class="app-presets__bottom">
				<button @click="showPresets" class="app-btn app-btn--round app-btn--outline" type="button">
					{{ isShowMorePresets ? $t('buttons.show_less') : $t('buttons.show_more') }}
				</button>
			</div>
		</template>
		<div v-else class="app-presets__message-holder">
			<p class="app-presets__message">
				{{ $t('messages.no_filters_message') }}
			</p>
		</div>
	</section>
</template>

<script>
export default {
	name: "PresetSelection",

	components: {
	},

	props: {
		presets: Array,
		current_company_name: {
			type: String,
			default: ''
		},
		show_more_presets: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			loading: true,
			isShowMorePresets: false,
			searchModel: '',
			filteredPresets: this.presets
		};
	},

	computed: {
		isShowClearSearchBtn() {
			return this.searchModel === '' ? false : true;
		}
	},

	methods: {
		generateRandomNamber(limit) {
			return Math.floor(Math.random() * limit) + 1;
		},

		searchPresets() {
			let presets = this.presets;

			if (this.searchModel.length !== 0) {
				let query = this.searchModel.toLowerCase();

				presets = presets.filter((preset) => {
					if (preset.name) {
						return preset.name.toLowerCase().includes(query)
					}
				})
			}

			this.filteredPresets = presets;
		},

		clearSearch() {
			this.searchModel = '';
			this.filteredPresets = this.presets;
		},

		showPresets() {
			this.isShowMorePresets = !this.isShowMorePresets;
		}
	}
};
</script>
